import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  FetchDataTypes,
  FetchSecurityMaster,
  ReportsDownload,
} from "../../api/api";
import Cookies from "js-cookie";
import { Viewer } from "@grapecity/activereports-react";
import "@grapecity/activereports/styles/ar-js-viewer.css";
import { Button } from "../../components/Button/Button";
//import reportTemplate from './myreport.rdlx';
import _ from "lodash";
import { Link, useParams } from "react-router-dom";
import { BASE_URL, API_REPORTS } from "../../api/api";
import moment from "moment";
interface ReportParameter {
  reportParameterID: number;
  reportID: number;
  parameterID: number;
  parameterName: string;
  parameterType: string;
  parameterOrderID: number;
  parameterNotes: string | null;
}

interface FormProps {
  reportParameters: ReportParameter[];
}
interface MyReportViewerProps {}

interface InitialFormData {
  FundID: string;
  ParticipantID: string;
  YearStartDate: string;
  BeginDate: string;
  EndDate: string;
}

//const Form: React.FC<FormProps> = ({ reportParameters }) => {
const ReportsDetails: React.FC<FormProps> = ({ reportParameters }) => {
  const [datalist, setDatalist] = useState<any[]>();

  const [fileType, setFileType] = useState<string>("pdf");
  const [newPayload, setNewPayload] = useState<any>("");
  const [selectedname, setSelectedname] = useState<any>("");
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isViewLoading, setIsViewLoading] = useState(false);
  const [isViewValidation, setIsViewValidation] = useState(false);
  const { reportId } = useParams();
  const viewerRef = useRef<HTMLIFrameElement | null>(null);
  const selectedClient: any = Cookies.get("client");
  const sessionId = Cookies.get("session_id");
  const [fundList, setFundList] = useState<any>(null);
  const [participantList, setParticipantList] = useState<any>(null);
  const [selected, setSelected] = useState<any>([]);
  const [selectedReport, setSelectedReport] = useState<any>({});
  const [showValidate, setShowValidate] = useState(false);

  const defaultFundID = String(fundList?.[0]?.fundID);
  const defaultParticipantID = String(0);

  const startDateOfYear = moment().startOf("year");
  const currentDate = moment();
  const currentWeekOfMonth = Math.ceil(currentDate.date() / 7);

  const formattedStartDate = startDateOfYear.format("YYYY-MM-DD");
  let startDate = currentDate.format("YYYY-MM-DD");
  let endDate = currentDate.format("YYYY-MM-DD"); // Default to current date
  const checkDateType = datalist?.some((e: any) => {
    return (
      (e.parameterType === "smalldatetime" &&
        e.parameterName === "BeginDate") ||
      (e.parameterType === "smalldatetime" && e.parameterName === "EndDate")
    );
  });
  if (
    currentWeekOfMonth === 1 ||
    currentWeekOfMonth === 2 ||
    currentWeekOfMonth === 3 ||
    currentWeekOfMonth === 4 ||
    currentWeekOfMonth === 5
  ) {
    const previousMonth = currentDate.clone().subtract(1, "months");
    startDate = checkDateType
      ? previousMonth.startOf("month").format("YYYY-MM-DD")
      : previousMonth.startOf("month").format("YYYY-MM-DDTHH:mm:ss");
    endDate = checkDateType
      ? previousMonth.endOf("month").format("YYYY-MM-DD")
      : previousMonth.endOf("month").format("YYYY-MM-DDTHH:mm:ss");
  }

  const initialFormData: InitialFormData = {
    FundID: defaultFundID ?? "",
    ParticipantID: defaultParticipantID ?? "",
    YearStartDate: formattedStartDate,
    BeginDate: startDate,
    EndDate: endDate,
  };

  const [formData, setFormData] = useState<{ [key: string]: any }>(
    initialFormData
  );

  useEffect(() => {
    if (selected.length > 1) {
      setSelected([selected[selected.length - 1]]);
      setFormData({});
      //setDateValue("");
    }
    setFormData((prevData) => ({
      ...prevData,
      FundID: defaultFundID,
      ParticipantID: defaultParticipantID,
    }));
  }, [selected, defaultFundID, defaultParticipantID]);

  useEffect(() => {
    if (reportId) {
      const reportIdNumber = parseInt(reportId, 10);
      FetchDataTypes(
        "ReportParameters",
        parseInt(selectedClient),
        Cookies.get("newJwt")
      )
        .then((response) => response?.json())
        .then((response) => {
          setDatalist(
            response.filter((item: any) => item.reportID === reportIdNumber)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [reportId]);

  useEffect(() => {
    if (reportId) {
      const reportIdNumber = parseInt(reportId, 10);
      FetchDataTypes("Reports", parseInt(selectedClient), Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setSelectedname(
            response.filter((item: any) => item.reportID === reportIdNumber)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [reportId]);

  useEffect(() => {
    if (reportId) {
      const reportIdNumber = parseInt(reportId, 10);
      FetchDataTypes("Reports", parseInt(selectedClient), Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setSelectedReport(
            response.filter((item: any) => item.reportID === reportIdNumber)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const [selectedFundID, setSelectedFundID] = useState(fundList?.[0]?.fundID);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "BeginDate" || name === "EndDate") {
      formattedValue = moment(value).format("YYYY-MM-DDTHH:mm:ss");
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      [name]: formattedValue,
    });

    if (e.target.name === "FundID") {
      setSelectedFundID(e.target.value);
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (fundList && fundList.length > 0) {
      setSelectedFundID(fundList[0].fundID);
    }
  }, [fundList]);

  function formatDate(dateString: string): string {
    const [year, month, day] = dateString?.split("-");
    return `${month}/${day}/${year}`;
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsViewValidation(true);
    //const payload = { fileType: fileType, Parameters: formData };
    const parametersArray = Object.entries(formData).map(([key, value]) => ({
      parameterName: key,
      value: value,
    }));

    parametersArray.push(
      {
        parameterName: "ClientID",
        value: parseInt(selectedClient),
      },
      {
        parameterName: "SessionID",
        value: "testSession",
      }
    );

    if (reportId && !showValidate) {
      setIsBtnLoading(true);
      const payload = {
        type: "activereport",
        fileType: fileType,
        aciveReport: {
          reportId: reportId,
          Parameters: parametersArray.map((param) => ({
            Name: param.parameterName,
            Value:
              param.parameterName === "BeginDate" ||
              param.parameterName === "EndDate"
                ? checkDateType
                  ? moment(param.value).format("YYYY-MM-DD")
                  : moment(param.value).format("YYYY-MM-DDTHH:mm:ss")
                : param.value,
          })),
        },
      };
      fetch(`${BASE_URL}/${API_REPORTS}/api/ims/reports/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("newJwt")}`,
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          setIsBtnLoading(false);
          const payload = {
            fileType: "",
            Parameters: parametersArray.map((param) => ({
              Name: "",
              Value: "",
            })),
          };
          if (response.ok) {
            // Success

            return response.blob();
          } else {
            // Error
            setIsBtnLoading(false);
            console.error("Failed to download file");
          }
        })

        .then((blob) => {
          // create a download link
          if (blob) {
            // add a check for undefined blob
            // create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${selectedname[0]?.reportClassName}.${fileType}`;
            // simulate a click on the link to trigger the download
            link.click();
          }
        })

        .catch((error) => {
          setIsBtnLoading(false);
          console.error("An error occurred while downloading the file", error);
        });
    }
  };

  const handleFileTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setFileType(event.target.value);
  };
  useEffect(() => {
    if (
      datalist?.some((param) => param.parameterName === "ParticipantID") &&
      formData?.ParticipantID === "0"
    ) {
      setShowValidate(true);
    } else if (formData?.ParticipantID !== "0") {
      setShowValidate(false);
    }
  }, [datalist, formData]);

  const handlePreviewClick = () => {
    setIsViewLoading(true);
    setIsViewValidation(true);
    const parametersArray = Object.entries(formData).map(([key, value]) => ({
      parameterName: key,
      value: value,
    }));

    parametersArray.push(
      {
        parameterName: "ClientID",
        value: parseInt(selectedClient),
      },
      {
        parameterName: "SessionID",
        value: "testSession",
      }
    );

    if (reportId && !showValidate) {
      const payload = {
        type: "activereport",
        fileType: fileType,
        aciveReport: {
          reportId: reportId,
          Parameters: parametersArray.map((param) => ({
            Name: param.parameterName,
            Value:
              param.parameterName === "BeginDate" ||
              param.parameterName === "EndDate"
                ? checkDateType
                  ? moment(param.value).format("YYYY-MM-DD")
                  : moment(param.value).format("YYYY-MM-DDTHH:mm:ss")
                : param.value,
          })),
        },
      };
      fetch(`${BASE_URL}/${API_REPORTS}/api/ims/reports/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("newJwt")}`,
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          if (viewerRef.current) {
            const url = URL.createObjectURL(blob);
            viewerRef.current.src = url;
          }
        })

        .catch((error) => {
          console.error("An error occurred while downloading the file", error);
        });
    }
  };

  useEffect(() => {
    FetchSecurityMaster(
      "Fund",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setFundList(response);
    });

    FetchSecurityMaster(
      "FundParticipant",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setParticipantList(response);
    });
  }, []);

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Reports</h1>
      </div>

      <div className="card w-100 p-4">
        {showValidate && isViewValidation ? (
          <div
            className="alert alert-danger position-absolute p-2"
            style={{ top: "-24px", width: "100%", left: "0" }}
            role="alert"
          >
            Please Select ParticipantID
          </div>
        ) : null}

        <div className="col-md-5 mt-4 d-flex align-items-center">
          <label className="col-sm-4 col-form-label">Report Name(ID)</label>
          <div className="col-sm-8">
            <b>
              {selectedReport[0]?.reportName}({selectedReport[0]?.reportID})
            </b>
          </div>
        </div>

        {datalist?.length !== 0 ? (
          <form
            onSubmit={handleSubmit}
            className="row card w-100"
            style={{ boxShadow: "none" }}
          >
            {datalist?.map((item: any) => {
              return (
                <div className="col-md-5 mt-4 d-flex">
                  <label
                    htmlFor={item.parameterName}
                    className="col-sm-4 col-form-label"
                  >
                    {item.parameterName}
                  </label>
                  <div className="col-sm-8">
                    {item?.parameterName === "FundID" ? (
                      <select
                        className="form-control"
                        name={item?.parameterName}
                        onChange={handleChange}
                        defaultValue={
                          formData?.FundID !== undefined
                            ? fundList?.[0]?.fundID
                            : null
                        } // Set the selected value to the first fundID in fundList
                        key={selected}
                        value={selectedFundID}
                      >
                        <option value="0">Select</option>
                        {fundList?.map((e: any) => {
                          return (
                            <option value={e.fundID} key={e.fundID}>
                              {e.fund}
                            </option>
                          );
                        })}
                      </select>
                    ) : null}
                    {item?.parameterName === "ParticipantID" ? (
                      <select
                        className="form-control"
                        name={item.parameterName}
                        onChange={handleChange}
                        key={selected}
                      >
                        <option value="0">Select</option>
                        {participantList?.map((e: any) => {
                          return (
                            <option value={e.participantID} key={e.accountID}>
                              {e.participantName}
                            </option>
                          );
                        })}
                      </select>
                    ) : null}
                    {item?.parameterType === "smalldatetime" &&
                    item?.parameterName === "YearStartDate" ? (
                      <input
                        className="form-control"
                        type="date"
                        name={item.parameterName}
                        id={item.parameterName}
                        onChange={handleChange}
                        //value={formData[item.parameterName] || ""}
                        defaultValue={formattedStartDate}
                        required
                      />
                    ) : null}
                    {item?.parameterType === "smalldatetime" &&
                    item?.parameterName === "BeginDate" ? (
                      <input
                        className="form-control"
                        type={`${
                          item.parameterType === "smalldatetime"
                            ? "date"
                            : "datetime-local"
                        }`}
                        name={item.parameterName}
                        id={item.parameterName}
                        onChange={handleChange}
                        defaultValue={startDate}
                        min={formData.YearStartDate || ""}
                        max={formData.EndDate || ""}
                        required
                      />
                    ) : null}
                    {item?.parameterType === "smalldatetime" &&
                    item?.parameterName === "EndDate" ? (
                      <input
                        className="form-control"
                        type={`${
                          item.parameterType === "smalldatetime"
                            ? "date"
                            : "datetime-local"
                        }`}
                        name={item.parameterName}
                        id={item.parameterName}
                        onChange={handleChange}
                        //value={formData[item.parameterName] || ""}
                        defaultValue={endDate}
                        required
                      />
                    ) : null}
                    {item?.parameterType === "int" &&
                    item?.parameterName !== "FundID" &&
                    item?.parameterName !== "ParticipantID" ? (
                      <input
                        className="form-control"
                        type={item.parameterType === "int" ? "number" : "text"}
                        name={item.parameterName}
                        id={item.parameterName}
                        onChange={handleChange}
                        value={formData[item.parameterName] || ""}
                        required
                      />
                    ) : null}
                  </div>
                </div>
              );
            })}
            {datalist ? (
              <>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">Export As</label>
                  <div className="col-sm-8">
                    <select
                      name="fileType"
                      id="fileType"
                      className="form-control"
                      onChange={handleFileTypeChange}
                    >
                      <option value="pdf">PDF</option>
                      <option value="xlsx">Excel</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-12 mb-4">
                  <Button
                    type="submit"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end"
                    size="medium"
                    children="Download"
                    showLoading={isBtnLoading}
                  />

                  <button
                    type="button"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end mx-2"
                    onClick={handlePreviewClick}
                  >
                    View
                  </button>

                  <button
                    type="button"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-link float-end"
                  >
                    <Link to={`/portal/reports`}>Cancel</Link>
                  </button>
                </div>
              </>
            ) : null}
          </form>
        ) : (
          <div className="row w-100 card p-4">
            <h4 className="text-center mt-4 mb-2">No Data Available</h4>
            <p className="text-center">
              <Link to={`/portal/reports`}>Click here</Link> to Reports Listing{" "}
            </p>
          </div>
        )}
        {isViewLoading ? (
          <iframe ref={viewerRef} title="Report" width="100%" height="800px" />
        ) : null}
      </div>
    </div>
  );
};

export { ReportsDetails };
